import React, { useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

// store
import { storeSet } from '../../store';
import { historyStore } from '../../store/historyStore';

// helpers
import { CUE_SHEET_STATUS_LABELS } from '../../helpers/cueSheetStatuses';

// components
import FormField from '../FormField';
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../ButtonWrapper/components/ButtonFormSubmit';
import ModalDialog from '../ModalDialog';

const STATUS_OPTIONS = [
    { value: '', label: '—' },
    ...Object.entries(CUE_SHEET_STATUS_LABELS).map(([value, label]) => ({ value, label })),
];

const ModalEditCueSheetItem = ({ visible, onHide, projectId, item }) => {
    const [loading, setLoading] = useState(false);
    const {
        control,
        handleSubmit,
        formState: { isValid },
        reset,
        setValue,
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            label: '',
            title: '',
            timecode: '',
            status: '',
        }
    });

    useEffect(() => {
        if (item) {
            reset({
                label: item.label ?? '',
                title: item.title ?? '',
                timecode: item.timecode ?? '',
                status: item.status ?? '',
            });
        }
    }, [item, visible]);

    const handleRemoveTimecode = () => {
        setValue('timecode', null, { shouldValidate: true });
    };

    const onSubmit = async (formData) => {
        setLoading(true);
        try {
            historyStore.getState().beginAction('Edit');
            await storeSet('saveCueSheetUpdates', projectId, [{
                id: item.id,
                title: formData.title,
                label: formData.label || null,
                timecode: formData.timecode || null,
                status: formData.status || null,
            }]);
            onHide();
        } catch (error) {
            // Error already displayed by store action
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        onHide();
    };

    if (!visible || !item) return null;

    return (
        <ModalDialog
            additionalClasses={['modalEditCueSheetItem']}
            header={__('Modifica elemento CueSheet', 'soundbetween')}
            visible={visible}
            onSubmit={handleSubmit(onSubmit)}
            onHide={handleCloseModal}>
            <form className="appForm formInModal" onSubmit={handleSubmit(onSubmit)}>
                <FormField
                    type="text"
                    name="label"
                    label={__('Label', 'soundbetween')}
                    placeholder={__('es 1m3', 'soundbetween')}
                    control={control}
                />

                <FormField
                    control={control}
                    name="title"
                    label={__('Titolo', 'soundbetween')}
                    placeholder="Titolo"
                    type="text"
                    rules={{
                        required: __('È obbligatorio', 'soundbetween'),
                    }}
                />

                <FormField
                    control={control}
                    name="timecode"
                    label={__('Timecode', 'soundbetween')}
                    placeholder="00:00:00:00"
                    type="text"
                    rules={{ required: false }}
                />

                <ButtonFlat type="button" onClick={handleRemoveTimecode}>
                    {__('Rimuovi timecode', 'soundbetween')}
                </ButtonFlat>

                <FormField
                    control={control}
                    name="status"
                    label={__('Stato', 'soundbetween')}
                    type="select"
                    options={STATUS_OPTIONS}
                />

                <div className="appFormActions">
                    <ButtonFlat size="lg" type="button" onClick={handleCloseModal}>
                        {__('Annulla', 'soundbetween')}
                    </ButtonFlat>
                    <ButtonFormSubmit disabled={loading || !isValid}>
                        {__('Salva e continua', 'soundbetween')}
                    </ButtonFormSubmit>
                </div>
            </form>
        </ModalDialog>
    );
};

export default ModalEditCueSheetItem;
